import { Box, Typography } from "@mui/material";
import { Landmark } from "lucide-react";

// ==============================|| LOGOBIG SVG ||============================== //

export const LogoBig = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ 
            width: 64, height: 64, 
            borderRadius: 1.5, 
            background: 'linear-gradient(to bottom, #1A237E, #0D47A1)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(26, 35, 126, 0.4)'
        }}>
            <Landmark color="#FFD54F" size={36} strokeWidth={2} />
        </Box>
        <Typography variant="h1" sx={{ fontWeight: 500, color: '#F8FAFC' }}>
            Trade<span style={{ color: '#22D3EE', fontWeight: 400 }}>Tailor</span>
        </Typography>
    </Box>
);

export const LogoBigDark = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ 
            width: 64, height: 64, 
            borderRadius: 1.5, 
            background: 'linear-gradient(to bottom, #1A237E, #0D47A1)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(26, 35, 126, 0.4)'
        }}>
            <Landmark color="#FFD54F" size={36} strokeWidth={2} />
        </Box>
        <Typography variant="h1" sx={{ fontWeight: 500, color: '#000000' }}>
            Trade<span style={{ color: '#22D3EE', fontWeight: 400 }}>Tailor</span>
        </Typography>
    </Box>
    
);

export default LogoBig;
